import { Text as TextC, TextProps } from '@chakra-ui/react';

export function Text(props: TextProps) {
  return <TextC color="#292927" fontWeight={500} {...props} />;
}
